import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { Icon } from '@material-ui/core';
import { SIDE_NAV_ICON } from '../../../Common';
import LinkedDataIcon from '../../atoms/LinkedDataIcon';

export interface BreadcrumbItem {
  icon?: string;
  text: string;
  to?: string;
  onClick?: () => void;
  className?: string;
  gaSpotEvent?: string;
}

interface BreadcrumbsListProps {
  items: Array<BreadcrumbItem>;
}

const BreadcrumbsList: React.FC<BreadcrumbsListProps> = ({ items }) => {
  return (
    <div className='u-float-left'>
      <ul className='uc-breadcrumb u-mb8'>
        {items.map((item, index) => (
          <BreadcrumbsLink item={item} index={index} />
        ))}
      </ul>
    </div>
  );
};

interface BreadcrumbsLinkProps {
  item: BreadcrumbItem;
  index: number;
}

const BreadcrumbsLink: React.FC<BreadcrumbsLinkProps> = ({ item, index }) => {
  const renderBreadcrumbIcon = (breadcrumbIcon: string) => {
    if (SIDE_NAV_ICON.LINKED_DATA_RESULT === breadcrumbIcon) {
      return <LinkedDataIcon className='uc-breadcrumb__item-icon' data-testid='breadcrumbIcon' fontSize='small' />;
    }
    return (
      <Icon className='uc-breadcrumb__item-icon' data-testid='breadcrumbIcon'>
        {breadcrumbIcon}
      </Icon>
    );
  };

  useEffect(() => {
    if (!item.className || !item.gaSpotEvent) return;
    document.querySelector(`.${item.className}`)?.setAttribute('onclick', item.gaSpotEvent);
  }, [item]);

  return (
    <li className='uc-breadcrumb__item' key={index} data-testid='breadcrumbList'>
      {item.to ? (
        <Link to={item.to} onClick={item.onClick} data-testid='breadcrumbLink' className={classNames(item.className)}>
          {item.icon && renderBreadcrumbIcon(item.icon)}
          <span data-testid='breadcrumbLinkText'>{item.text}</span>
        </Link>
      ) : item.onClick ? (
        <a
          href='#'
          onClick={(e) => {
            e.preventDefault();
            item.onClick?.();
          }}
          data-testid='breadcrumbLink'
          className={classNames(item.className, 'uc-breadcrumb__link')}>
          {item.icon && renderBreadcrumbIcon(item.icon)}
          <span data-testid='breadcrumbLinkText'>{item.text}</span>
        </a>
      ) : (
        <span data-testid='breadcrumbText'>{item.text}</span>
      )}
    </li>
  );
};

export default BreadcrumbsList;
